import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import ColorModeContext from '../../layout/themeContext';
import { DEFAULT_APP_DISPLAY_NAME } from '../../constants/appBrandingDefaults';

const toText = (value) => (typeof value === 'string' ? value.trim() : '');

export default function PageMetadata({
  title,
  includeAppName = true,
  appNameOverride,
  separator = ' - ',
}) {
  const colorMode = useContext(ColorModeContext)?.colorMode;
  const contextAppName = toText(colorMode?.appName);
  const routeTitle = toText(title);
  const appName = toText(appNameOverride) || contextAppName || DEFAULT_APP_DISPLAY_NAME;

  const fullTitle =
    includeAppName && routeTitle ? `${routeTitle}${separator}${appName}` : routeTitle || appName;

  if (!fullTitle) return null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
    </Helmet>
  );
}
